// Inline SVG for generic user avatar
const UserAvatarSVG = () => (
    <svg width="40" height="40" viewBox="0 0 48 48" fill="none" xmlns="http://www.w3.org/2000/svg">
        <circle cx="24" cy="24" r="24" fill="#F63040" />
        <circle cx="24" cy="18.5" r="8.5" fill="#fff" />
        <ellipse cx="24" cy="34" rx="13" ry="8" fill="#fff" />
        <ellipse cx="24" cy="34" rx="11" ry="7" fill="#57565B" fillOpacity="0.12" />
        <ellipse cx="24" cy="34" rx="8.5" ry="5.5" fill="#fff" fillOpacity="0.5" />
    </svg>
);

export default UserAvatarSVG;